import { permissionKeys } from './Keys';
import { permissionModulesKeys } from './ModulesKeys';

export const permissionUrlKeys = {
	'dashboard': permissionKeys.Dashboard,
	'agent-dashboard': permissionKeys.Dashboard,
	campaigns: permissionKeys.Campaigns,
	team: permissionKeys.Team,
	'dial-pad': permissionKeys.Dialpad,
	'live-monitor': permissionKeys.LiveMonitor,

	reporting: permissionModulesKeys.Reports,
	settings: permissionModulesKeys.Settings,
	message: permissionModulesKeys.ChatScreen,

	// ? MESSAGE
	'nlp-agent': permissionKeys.NlpAgent,
	'nlp-dashboard': permissionKeys.NlpDashboard,
	'rcs-dashboard': permissionKeys.RcsDashboard,
	'rcs-provider': permissionKeys.RcsProvider,
	'smpp-provider': permissionKeys.SmppProvider,
	'sms-dashboard': permissionKeys.SmsDashboard,
	'sms-provider': permissionKeys.SmsProvider,
	'sms-sender': permissionKeys.SmsSender,
	'sms-template': permissionKeys.SmsTemplate,
	'whatsapp-dashboard': permissionKeys.WhatsappDashboard,
	'whatsapp-number': permissionKeys.WhatsappNumber,
	'whatsapp-template': permissionKeys.WhatsappTemplate,
	'email-provider': permissionKeys.EmailProvider,
	'email-template': permissionKeys.EmailTemplate,

	// ? REPORTS
	'voice-report': permissionKeys.VoiceCdrReport,
	'outbound-cdr-report': permissionKeys.OutboundCdrReport,
	'inbound-cdr-report': permissionKeys.InboundCdrReport,
	'dnc-cdr-report': permissionKeys.DncCdrReport,
	'agent-outbound-cdr-report': permissionKeys.AgentOutboundCdrReport,
	'agent-outbound-drop-report': permissionKeys.AgentOutboundDropReport,
	'agent-inbound-cdr-report': permissionKeys.AgentInboundCdrReport,
	'agent-inbound-missed-report': permissionKeys.AgentInboundMissedReport,
	'user-summary': permissionKeys.UserSummaryReport,
	'break-summary': permissionKeys.BreakSummaryReport,
	'despose-report': permissionKeys.DisposeSummaryReport,
	'callback-report': permissionKeys.CallbackReport,
	'broadcast-cdr-report': permissionKeys.BroadcastCdrReport,
	'cpaas-outbound-cdr-report': permissionKeys.CpassOutboundCdrReport,
	'cpaas-inbound-cdr-report': permissionKeys.CpassInboundCdrReport,
	'webhooks-report': permissionKeys.WebhookReport,
	'team-summary': permissionKeys.TeamSummaryReport,
	'campaign-summary': permissionKeys.CampaignSummaryReport,
	'auto-dispose-summary': permissionKeys.AutoDisposeSummaryReport,
	'agent-heat-map': permissionKeys.AgentHeatMapReport,
	'lead-status': permissionKeys.LeadStatusReport,
	'contact-list-call-statistics':
		permissionKeys.ContactListCallStatisticsReport,
	'contact-list-quality-assurance':
		permissionKeys.ContactListQualityAssuranceReport,
	'duplicate-lead-identification-report':
		permissionKeys.DuplicateLeadIdentificationReport,

	// ? SETTING
	user: permissionKeys.User,
	skills: permissionKeys.Skill,
	permissions: permissionKeys.Permission,
	providers: permissionKeys.Provider,
	phonenumbers: permissionKeys.PhoneNumber,
	integrations: permissionKeys.Integration,
	'call-internal-actions': permissionKeys.MissedCallToCampaign,
	dispose: permissionKeys.Disposition,
	country: permissionKeys.Country,
	contact: permissionKeys.Contact,
	'contact-list': permissionKeys.Contact,
	'contact-list-private': permissionKeys.Contact,
	contactinfo: permissionKeys.Contact,
	'contact-details': permissionKeys.Contact,
	sounds: permissionKeys.Sound,
	carrierrate: permissionKeys.CarrierRate,
	dnc: permissionKeys.Dnc,
	holiday: permissionKeys.Holiday,
	skillsmanage: permissionKeys.SkillMapping,
	'account-setting': permissionKeys.Account,
	break: permissionKeys.Break,
	flow: permissionKeys.Flow,
	flowdiagram: permissionKeys.Flow,
	'import-export': permissionKeys.ImportExport,
	'cti-popup': permissionKeys.PopupIntegration,
	webhook: permissionKeys.WebhookIntegration,
	logs: permissionKeys.Logs,
};



// WEBPACK FOOTER //
// src/modules/common/utils/Permission/UrlKeys.js